/* ENEA — stop collection product cards from flipping to the 2nd image on tap (2026-06-21)
 *
 * The theme's native swipeProductImages() (assets/theme.dev.js) binds touch handlers to
 * every .slider-track. On a TAP (no touchmove) its endX stays 0, so diff = endX - startX
 * is hugely negative and it mis-fires as a "swipe left", jumping to the 2nd image right
 * before the link navigates to the PDP.
 *
 * The custom __eneaCollectionSwipeV3 controller in assets/custom.js already owns this
 * gesture and correctly ignores taps, so we neutralize the redundant theme handler.
 * swipeProductImages is a global function; replacing it with a no-op (it runs after
 * theme.dev.js and before the theme's DOMContentLoaded init, and also covers the
 * infinite-scroll re-init call) stops the theme from ever binding its buggy
 * tap-as-swipe logic. Swiping still works via the custom controller.
 *
 * To revert: delete this file and its <script> tag in snippets/loading.liquid.
 */
(function () {
  if (window.__eneaKillThemeCardSwipe) return;
  window.__eneaKillThemeCardSwipe = true;
  try { window.swipeProductImages = function () {}; } catch (e) {}
})();
